// extracted by mini-css-extract-plugin
export default {"switch":"SwitchToggler_switch__JoMsy","slider":"SwitchToggler_slider__EwlA3","round":"SwitchToggler_round__w5zgR"};